import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav, Row, Col } from "react-bootstrap";
import "./navheader.css";
import CustomButton from "../shared/button/button";
import anandham_logo from "../../assets/logo/anandham_Logo.png";
import Padappai from "../../assets/images/card11.png";
import Kanchipuram from "../../assets/images/card22.png";
import Sholavaram from "../../assets/images/card33.png";
import Thiruporur from "../../assets/images/card44.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faBook,
  faBriefcase,
  faCaretDown,
  faPhone,
  faHourglassEnd,
  faHourglassHalf,
  faHourglassStart,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

export default function NavHeader() {
  const location = useLocation();
  // On the Sangamam thank-you page, the nav should be display-only —
  // no clickable/redirecting links. Every other page is unaffected.
  const hideNavLinks = location.pathname === "/sangamam-thankyou";

  useEffect(() => {
    const updateHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const [showOngoingDropdown, setShowOngoingDropdown] = useState(false);
  const [showProjectsDropdown, setShowProjectsDropdown] = useState(false);
  const [showProject, setShowProject] = useState("Padappai");

  const handleLinks = (path) => {
    window.location.href = `/${path}`;
  };

  const handleOngoingToggle = () => {
    setShowOngoingDropdown((prev) => !prev);
  };

  const handleProjectSelect = (project) => {
    setShowProject(project);
  };

  return (
    <div className="nav-header-lap">
      {/* ── MAIN NAV BAR ── */}
      <div>
        <div className="nav-main-container white-bg py-3 px-2">
          {/* Logo */}
          <div
            href="#"
            className="nav-header-logo"
            onMouseOver={() => {
              setShowProjectsDropdown(false);
            }}
          >
            {hideNavLinks ? (
              <img
                className="home-logo-out"
                src={anandham_logo}
                alt="Anandhamplots Logo"
              />
            ) : (
              <a className="navbar-brand" href="/">
                <img
                  className="home-logo-out"
                  src={anandham_logo}
                  alt="Anandhamplots Logo"
                />
              </a>
            )}
          </div>

          {/* Nav links + enquire box */}
          <div className="nav-header-content">
            <Nav className="nav-container">
              {!hideNavLinks && (
                <Nav.Link
                  href="/"
                  className="nav-header-text px-3"
                  onMouseOver={() => {
                    setShowProjectsDropdown(false);
                  }}
                >
                  <h5>Home</h5>
                </Nav.Link>
              )}

              {/* Projects dropdown */}
              {!hideNavLinks && (
                <div
                  className="nav-project-wrapper"
                  onMouseOver={() => {
                    setShowProjectsDropdown(true);
                  }}
                >
                  <Nav.Link
                    href="#"
                    className="nav-header-text px-3"
                    onClick={() => {
                      setShowProjectsDropdown(!showProjectsDropdown);
                    }}
                  >
                    <h5>Projects</h5>
                  </Nav.Link>

                  {showProjectsDropdown && (
                    <div
                      className="project-dropdown shadow"
                      onMouseLeave={() => {
                        setShowProjectsDropdown(false);
                      }}
                    >
                      {/* Column 1 - Image */}
                      <Col md={3} xs={12} className="mb-3 mb-md-0">
                        <div className="project-image-div">
                          {showProject === "Padappai" ? (
                            <img
                              src={Padappai}
                              alt={`Project-${showProject}`}
                              className="project-image"
                            />
                          ) : showProject === "Kanchipuram" ? (
                            <img
                              src={Kanchipuram}
                              alt={`Project-${showProject}`}
                              className="project-image"
                            />
                          ) : showProject === "Thiruporur" ? (
                            <img
                              src={Thiruporur}
                              alt={`Project-${showProject}`}
                              className="project-image"
                            />
                          ) : (
                            <img
                              src={Sholavaram}
                              alt={`Project-${showProject}`}
                              className="project-image"
                            />
                          )}
                        </div>
                      </Col>

                      {/* Column 2 - Buttons */}
                      <Col
                        md={3}
                        xs={12}
                        className="mb-3 mb-md-0 project-column"
                      >
                        <div className="project-column-btns">
                          <CustomButton
                            title="Completed Projects"
                            value="Padappai"
                            textcolor={
                              showProject === "Padappai" ? "light" : "btn"
                            }
                            btnBg={
                              showProject === "Padappai" ? "green" : "white"
                            }
                            textWeight={700}
                            btnMinWidth="10rem"
                            btnBorderRadius="5px"
                            handleClick={() => {
                              setShowProject("Padappai");
                              setShowOngoingDropdown(false);
                            }}
                          />
                          <br />
                          <CustomButton
                            title="Ongoing Projects"
                            value="Ongoing"
                            textcolor={
                              ["Kanchipuram", "Sholavaram"].includes(
                                showProject,
                              )
                                ? "light"
                                : "btn"
                            }
                            btnBg={
                              ["Kanchipuram", "Sholavaram"].includes(
                                showProject,
                              )
                                ? "green"
                                : "white"
                            }
                            textWeight={700}
                            btnMinWidth="10rem"
                            btnBorderRadius="5px"
                            handleClick={handleOngoingToggle}
                          />
                          <div
                            className={`ongoing-dropdown ${showOngoingDropdown ? "active" : ""}`}
                          >
                            <button
                              className={`dropdown-item ${showProject === "Kanchipuram" ? "active" : ""}`}
                              onClick={() => handleProjectSelect("Kanchipuram")}
                              onDoubleClick={() => handleLinks("kanchipuram")}
                            >
                              Kanchipuram
                            </button>
                            <button
                              className={`dropdown-item ${showProject === "Sholavaram" ? "active" : ""}`}
                              onClick={() => handleProjectSelect("Sholavaram")}
                              onDoubleClick={() => handleLinks("Sholavaram")}
                            >
                              Sholavaram
                            </button>
                            <button
                              className={`dropdown-item ${showProject === "Thiruporur" ? "active" : ""}`}
                              onClick={() => handleProjectSelect("Thiruporur")}
                              onDoubleClick={() => handleLinks("Sangamam")}
                            >
                              Thiruporur
                            </button>
                          </div>
                        </div>
                      </Col>

                      {/* Column 3 - Content */}
                      <Col
                        md={2}
                        xs={12}
                        className="mb-3 mb-md-0 project-column"
                      >
                        {showProject === "Padappai" ? (
                          <div className="project-column-content">
                            <h5 className="green-text">Featured Projects</h5>
                            <p>
                              Explore our latest and most exciting developments.
                            </p>
                            <h4 className="green-text">
                              <b>PADAPPAI</b>
                            </h4>
                            <CustomButton
                              title="Know More"
                              value={"padappai"}
                              textcolor="light"
                              btnBg="green"
                              textWeight={700}
                              btnMinWidth="10rem"
                              btnBorderRadius="5px"
                              handleClick={handleLinks}
                            />
                          </div>
                        ) : showProject === "Kanchipuram" ? (
                          <div className="project-column-content">
                            <h5 className="green-text">Featured Projects</h5>
                            <p>
                              Explore our latest and most exciting developments.
                            </p>
                            <h4 className="green-text">
                              <b>KANCHIPURAM</b>
                            </h4>
                            <CustomButton
                              title="Know More"
                              value={"kanchipuram"}
                              textcolor="light"
                              btnBg="green"
                              textWeight={700}
                              btnMinWidth="10rem"
                              btnBorderRadius="5px"
                              handleClick={handleLinks}
                            />
                          </div>
                        ) : showProject === "Thiruporur" ? (
                          <div className="project-column-content">
                            <h5 className="green-text">Featured Projects</h5>
                            <p>
                              Explore our latest and most exciting developments.
                            </p>
                            <h4 className="green-text">
                              <b>Thiruporur</b>
                            </h4>
                            <CustomButton
                              title="Know More"
                              value={"sangamam"}
                              textcolor="light"
                              btnBg="green"
                              textWeight={700}
                              btnMinWidth="10rem"
                              btnBorderRadius="5px"
                              handleClick={handleLinks}
                            />
                          </div>
                        ) : (
                          <div className="project-column-content">
                            <h5 className="green-text">Featured Projects</h5>
                            <p>
                              Explore our latest and most exciting developments.
                            </p>
                            <h4 className="green-text">
                              <b>SHOLAVARAM</b>
                            </h4>
                            <CustomButton
                              title="Know More"
                              value={"sholavaram"}
                              textcolor="light"
                              btnBg="green"
                              textWeight={700}
                              btnMinWidth="10rem"
                              btnBorderRadius="5px"
                              handleClick={handleLinks}
                            />
                          </div>
                        )}
                      </Col>

                      {/* Column 4 - Map */}
                      <Col className="project-column" md={3} xs={12}>
                        <div className="project-column-site">
                          <Row>
                            {showProject === "Padappai" ? (
                              <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14078.526685138102!2d80.0330963!3d12.8871589!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52f7edcddad8af%3A0xaab3ad23b3682db0!2sRaunaq%20Foundations%20-%20Anandham%20-%20Plots%20in%20Padappai!5e1!3m2!1sen!2sin!4v1755963532322!5m2!1sen!2sin"
                                height="200"
                                width="60%"
                                style={{ border: "0" }}
                                allowfullscreen=""
                                loading="lazy"
                                title="Padappai"
                                referrerpolicy="no-referrer-when-downgrade"
                              ></iframe>
                            ) : showProject === "Kanchipuram" ? (
                              <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14080.572558071908!2d79.7111061!3d12.8507169!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52c3df1806e2c3%3A0x21754d7d64da3ca1!2sAnandham%20Plots%20-%20Konnerikuppam!5e1!3m2!1sen!2sin!4v1755963456686!5m2!1sen!2sin"
                                height="200"
                                width="60%"
                                style={{ border: "0" }}
                                allowfullscreen=""
                                loading="lazy"
                                title="Kanchipuram"
                                referrerpolicy="no-referrer-when-downgrade"
                              ></iframe>
                            ) : showProject === "Thiruporur" ? (
                              <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14088.11501901417!2d80.13736!3d12.7154802!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5257006790b693%3A0x270387706ee1d413!2sAkshaya%20Sangamam!5e1!3m2!1sen!2sin!4v1769442156160!5m2!1sen!2sin"
                                width="60%"
                                height="200"
                                style={{ border: "0" }}
                                allowfullscreen=""
                                loading="lazy"
                                title="Sangamam"
                                referrerpolicy="no-referrer-when-downgrade"
                              ></iframe>
                            ) : (
                              <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14058.496318192152!2d80.1564884!3d13.2387403!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a527de145ef4935%3A0xccfd18f693baecf2!2sAnandham%20Plots%20-%20Sholavaram!5e1!3m2!1sen!2sin!4v1755963347522!5m2!1sen!2sin"
                                height="200"
                                width="60%"
                                style={{ border: "0" }}
                                allowfullscreen=""
                                loading="lazy"
                                title="Sholavaram"
                                referrerpolicy="no-referrer-when-downgrade"
                              ></iframe>
                            )}
                          </Row>
                        </div>
                      </Col>
                    </div>
                  )}
                </div>
              )}

              {!hideNavLinks && (
                <Nav.Link
                  href="/aboutus"
                  className="nav-header-text px-3"
                  onMouseOver={() => {
                    setShowProjectsDropdown(false);
                  }}
                >
                  <h5>About Us</h5>
                </Nav.Link>
              )}

              {!hideNavLinks && (
                <Nav.Link
                  href="/blogs"
                  className="nav-header-text px-3"
                  onMouseOver={() => {
                    setShowProjectsDropdown(false);
                  }}
                >
                  <h5>Blogs</h5>
                </Nav.Link>
              )}

              {!hideNavLinks && (
                <Nav.Link
                  href="/careers"
                  className="nav-header-text px-3"
                  onMouseOver={() => {
                    setShowProjectsDropdown(false);
                  }}
                >
                  <h5>Careers</h5>
                </Nav.Link>
              )}

              {!hideNavLinks && (
                <Nav.Link
                  href="/contactus"
                  className="nav-header-text px-3"
                  onMouseOver={() => {
                    setShowProjectsDropdown(false);
                  }}
                >
                  <h5>Contact Us</h5>
                </Nav.Link>
              )}

              {/* ── ENQUIRE BOX ── */}
              <div
                className="nav-enquire-box"
                onMouseOver={() => {
                  setShowProjectsDropdown(false);
                }}
              >
                <div className="nav-enquire-top">
                  🚀 ENQUIRE NOW FOR A FREE SITE VISIT
                </div>
                <a href="tel:+919677079770" className="nav-enquire-num">
                  +91 9677 079 770
                </a>
              </div>
            </Nav>

            {/* Mobile hamburger */}
            {!hideNavLinks && (
              <button
                className="navbar-toggler toggle-btn"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNavbar"
                aria-controls="offcanvasNavbar"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            )}
          </div>

          {/* ── Off-canvas mobile menu ── */}
          {!hideNavLinks && (
            <div
              className="offcanvas offcanvas-end"
              tabIndex="-1"
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
            >
              <div className="offcanvas-header">
                <div>
                  <img
                    className="home-logo"
                    src={anandham_logo}
                    alt="Anandhamplots Logo"
                  />
                </div>
                <button
                  type="button"
                  className="btn-close closebtn"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>

              <div className="offcanvas-body">
                <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                  <li className="nav-item">
                    <div className="mobileview-nav">
                      <FontAwesomeIcon icon={faHouse} />{" "}
                      <a className="nav-link" href="/">
                        Home
                      </a>
                    </div>
                  </li>
                  <li className="nav-item">
                    <div className="mobileview-nav">
                      <FontAwesomeIcon icon={faBook} />{" "}
                      <a className="nav-link" href="aboutus">
                        About Us
                      </a>
                    </div>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="collapse"
                      href="#projectsSubmenu"
                      role="button"
                      aria-expanded="false"
                      aria-controls="projectsSubmenu"
                    >
                      <div className="mobileview-nav">
                        <FontAwesomeIcon icon={faBriefcase} /> Projects{" "}
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </a>
                    <div className="collapse" id="projectsSubmenu">
                      <ul className="list-unstyled ms-3">
                        <li>
                          <div className="mobileview-nav">
                            <FontAwesomeIcon icon={faHourglassEnd} />
                            <a className="nav-link" href="padappai">
                              Completed Projects
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="mobileview-nav">
                            <FontAwesomeIcon icon={faHourglassHalf} />
                            <a className="nav-link" href="kanchipuram">
                              Ongoing - Kanchipuram
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="mobileview-nav">
                            <FontAwesomeIcon icon={faHourglassStart} />
                            <a className="nav-link" href="sholavaram">
                              Ongoing - Sholavaram
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="mobileview-nav">
                            <FontAwesomeIcon icon={faHourglassStart} />
                            <a className="nav-link" href="sangamam">
                              Ongoing - Thiruporur
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="nav-item">
                    <div className="mobileview-nav">
                      <FontAwesomeIcon icon={faBook} />
                      <a className="nav-link" href="blogs">
                        Blogs
                      </a>
                    </div>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="careers">
                      Careers
                    </a>
                  </li>
                  <li className="nav-item">
                    <div className="mobileview-nav">
                      <FontAwesomeIcon icon={faPhone} />{" "}
                      <a className="nav-link" href="contactus">
                        Contact
                      </a>
                    </div>
                  </li>
                  {/* Mobile enquire numbers */}
                  <li className="nav-item mt-3">
                    <div className="mobile-enquire-box">
                      <div className="nav-enquire-top">
                        🚀 ENQUIRE NOW FOR A FREE SITE VISIT
                      </div>
                      <a
                        href="tel:+919884533533"
                        className="mobile-enquire-num"
                      >
                        +91 9884 533 533
                      </a>
                      <a
                        href="tel:+919677079770"
                        className="mobile-enquire-num"
                      >
                        +91 9677 079 770
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
